import React, { useState } from 'react';
import cn from 'classnames';

import {
	DynamicIconWrapper,
	Modal,
	SpinnerOverlay,
} from '@components/common';
import NavigateButtons from '@components/common/NavigateButtons';
import SkippedFiles
	from '@components/ModalComponents/ImportMapDataContainer/ImportMapData/ResultStatistic/SkippedFiles';

import { Icons } from '@icons/icons';

import { fileSaver } from '@utils/fileSaver';

import { IResultStatistic } from '@interfaces/import/import';

import styles from './ResultStatistic.module.scss';

interface IResultStatisticProps {
	onClose: () => void;
	fileName: string | undefined;
	executeImport: () => void;
	importStatistic: IResultStatistic;
	isLoadingResultStatistic: boolean;
	resultStatisticTitle: string;
	isViewDeleteCount: boolean;
}

const ResultStatistic = ({
	onClose,
	fileName,
	importStatistic,
	executeImport,
	isLoadingResultStatistic,
	resultStatisticTitle,
	isViewDeleteCount,
}: IResultStatisticProps) => {
	const [isOpenSkippedFilesModal, setIsOpenSkippedFilesModal] = useState(false);
	const isSkippedAssets = importStatistic?.skipped > 0;
	const skippedClasses = cn(styles.skipped, {
		[styles.link]: isSkippedAssets,
	});
	const isDisabledNext = importStatistic.skipped === importStatistic.allRows;

	const toggleSkippedFilesModal = () => isSkippedAssets && setIsOpenSkippedFilesModal(prevState => !prevState);

	const importHandler = () => {
		executeImport();
	};

	const handleDownloadReport = () => fileSaver(importStatistic.downloadLink);

	return (
		<div className={styles.resultStatisticContainer}>
			{isLoadingResultStatistic && <SpinnerOverlay />}
			<Modal
				isOpen={isOpenSkippedFilesModal}
				isScrollableContent
				onClose={toggleSkippedFilesModal}
				title={resultStatisticTitle}
			>
				<SkippedFiles
					handleDownloadReport={handleDownloadReport}
					importStatistic={importStatistic}
					toggleSkippedFilesModal={toggleSkippedFilesModal}
				/>
			</Modal>
			{!!importStatistic
				&& <>
					<div className={styles.fileText}>
						Your file <span>{fileName}</span> will be imported with the following result:
					</div>
					<div className={styles.processed}>
						{importStatistic.allRows} rows will be processed:
					</div>
					<div className={styles.rowsContainer}>
						<div className={styles.rows}>
							<div><span>Added:</span>&nbsp;{importStatistic.added}</div>
							<div><span>Updated:</span>&nbsp;{importStatistic.updated}</div>
							{isViewDeleteCount && <div><span>Deleted:</span>&nbsp;{importStatistic.deleted}</div>}
							<div>
								<span>Skipped:</span>&nbsp;
								<div
									className={skippedClasses}
									onClick={toggleSkippedFilesModal}
								>
									{importStatistic.skipped}
									<DynamicIconWrapper
										icon={Icons.downloadFileIcon}
										onClick={handleDownloadReport}
										tooltipLabel='Download report'
										withHover
									/>
								</div>
							</div>
						</div>
					</div>
				</>
			}
			<NavigateButtons
				disabledNext={isDisabledNext}
				nextText='Import'
				onCloseHandler={onClose}
				onNextHandler={importHandler}
			/>
		</div>
	);
};

export default ResultStatistic;
